<template >

  <div
    class="p-2"
  >
    <h1
        v-if="view_title"
        class="text-muted"
    >
      {{view_title}}
    </h1>

    <!-- btns -->
    <div
        class="text-end mb-1"
    >
      <template
          v-for="btn in btns"
      >
        <template
            v-if="btn.type == 'btn'"
        >
          <router-link
              :to="btn.link"
              :class="(btn.class? btn.class: '') + ' btn ms-2'"
          >
            <i
                v-if="btn.ico"
                :class="btn.ico"></i>
            <span class="d-none d-md-inline ms-2">{{btn.title}}</span>
          </router-link>
        </template>

        <template
            v-else-if="btn.type == 'link'"
        >
          <router-link
              :to="btn.link"
              :class="(btn.class? btn.class: '') + ' btn ms-2'"
          >
            <i
                v-if="btn.ico"
                :class="btn.ico"></i>
            <span class="d-none d-md-inline ms-2">{{btn.title}}</span>
          </router-link>

        </template>
        <template
            v-else-if="btn.type == 'btn_download_file'"
        >
          <div
              @click.prevent="downloadFile(btn.link)"
              :class="(btn.class? btn.class: '') + ' btn ms-2'"
          >
            <i
                v-if="btn.ico"
                :class="btn.ico"
            ></i>
            <span class="d-none d-md-inline ms-2">{{btn.title}}</span>
          </div>

        </template>



        <template
            v-else
        >
          <display-debug>
            <template #debugView>ViewGeneral btn: {{btn}}</template>
          </display-debug>
        </template>



      </template>

    </div>

    <!-- new data -->
    <div
      v-if="dataFormated"
    >
      <div
        v-for="row in dataFormated"
        class="row mb-2"
      >
        <template
            v-for="(cell, i) in row"
        >

          <div
            v-if="cell.value"
            :class="cell.class? cell.class: 'col' "
          >
            <h4
                v-if="cell.title"
                class="text-muted mb-1"
            >
              {{cell.title}}
            </h4>


            <!-- -->
            <view-item
                :data="cell.value"
            />

          </div>
        </template>
      </div>
    </div>



<!--
    <view-item
      :data="{x:'xxxxxx'}"
    />
-->


    <div
        v-if="dataObj"
        v-for="(row, index) in dataObj"
        class="row"
    >



      <div
          v-for="(col, index_c) in row"
          :class="col.class? col.class: 'col align-items-start col-12 col-md-auto p-2 '"
      >

        <template v-if="col.type == 'id'">
          <span class="fw-bold">ID #{{col.value}}</span>
        </template>

        <template v-else-if="col.type == 'varchar'">
          <span class="text-muted me-2">{{col.title}}:</span>
          <span class="fw-bold">{{col.value}}</span>
        </template>

        <template v-else-if="col.type == 'text'">
          <span class="text-muted me-2">{{col.title}}:</span><br/>
          <p class="ms-3">{{col.value}}</p>
        </template>

        <template v-else-if="col.type == 'image'">
          <span class="text-muted me-2">{{col.title}}:</span><br/>
          <div class="ms-4 mt-2">
            <image-component
                :image-id="col.value"
                :is_preview_only="true"
                thumb_class="none w-100"
            />
          </div>
        </template>


        <template v-else-if="col.type == 'bool'">
         <span
             v-marker-bool="col.value"
             class="me-2"
         ></span>
          <span class="text-muted me-2">{{col.title}}</span>

        </template>

        <template v-else-if="col.type == 'date'">
          <span class="text-muted me-2">{{col.title}}:</span>
          <span
              v-format-date="col.value.date"
              class="fw-bold"
          ></span>
        </template>

        <template v-else-if="col.type == 'datetime'">
          <span class="text-muted me-2">{{col.title}}:</span>
          <span
              v-format-date="col.value.date"
              class="fw-bold"
          ></span>
          &nbsp;
          <span
              class="fw-bold me-2"
              v-format-date:custom.time.timeOnly="col.value.date"></span>
        </template>

        <template v-else-if="col.type == 'datetime_range'">

          <span class="text-muted me-2">{{col.title}}:</span>
          <!-- -->
          <span
              v-format-date-range="{from: col.value.from.date, to: col.value.to.date}"
              class="fw-bold"
          ></span>
          &nbsp;
          <span
              v-format-date-range:custom.time.timerange="{from: col.value.from.date, to: col.value.to.date}"
              class="fw-bold"
          ></span>

        </template>

        <template v-else-if="col.type == 'json'">
          <span class="text-muted me-2">{{col.title}}:</span><br/>

          <div
              v-if="col.value"
              class="list-group ms-2"
          >
            <template
                v-for="(json, j) in col.value"
            >
              <template
                  v-if="typeof json == 'object'"
              >
                <div
                    class="list-group-item"
                >
                  <span class="text-muted me-2">{{json.title}}:</span>
                  <span class="fw-medium">{{json.value}}</span>
                </div>
              </template>
              <template
                  v-else
              >
                <div
                    class="list-group-item"
                >
                  <span class="text-muted">{{j}}:</span> {{json}}
                </div>
              </template>
            </template>
          </div>
        </template>

        <template v-else-if="col.type == 'history'">
          <span class="text-muted me-2">{{col.title}}:</span><br/>


          <div
              v-display-history="{values: col.value, options: col.options, $t: $t, limit: 2}"
          ></div>


          <!--
          <div
              v-if="col.value"
              class="list-group ms-2"
          >
            <template
                v-for="(json, j) in col.value"
            >
              <div
                  class="list-group-item"
              >
                <span class="text-muted">{{j}}:</span> {{json}}
              </div>


            </template>

          </div>
 -->
          <display-debug>
            <template #debugView>ViewGeneral history: {{index_c}}| {{col}}</template>
          </display-debug>
        </template>


        <template v-else>
          ELSE typ {{col.type}}

          <display-debug>
            <template #debugView>ViewGeneral item: {{index_c}}| {{col}}</template>
          </display-debug>
        </template>



      </div>



    </div>
  </div>








<!--
  <display-debug>
    <template #debugView>ViewGeneral: {{dataObj}}</template>
  </display-debug>
  -->

</template>

<script>

import axios from "axios";
import ImageComponent from "@/components/general/Image.vue";
import viewItem from "@/components/general/view/slots/item.vue";

export default {
  name: "ViewGeneral",
  components: {
    ImageComponent,
    viewItem
  },
  props: {
    "title": {
      type: [String],
      required: false,
      default: null,
    },
    "dataObj": {
      type: [Object],
      required: false,
      default: null,
    },
    "btns": {
      type: [Object],
      required: false,
      default: null,
    },
    "dataFormated": {
      type: [Object],
      required: false,
      default: null,
    },



    "returnData": [Object, String, Number],
    "reloadSignal": [Object, String, Number],
  },
  data() {
    return {
      inputModel: null,
    }
  },
  mounted() {

  },
  methods: {
    downloadFile(url) {

      let apiPath = '/class' + url
      console.log('dev download', apiPath)
      //console.log('dev downloadu apiPath', apiPath)
      axios.defaults.baseURL = this.getBaseRoot();
      axios({
        url: apiPath,
        method: 'get',
        withCredentials: true,
        headers: this.getRequestHeader(),
        responseType: "blob",
      }).then((response) => {
        const parsedUrl = new URL(this.getBaseRoot() + apiPath);
        const url = URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        //console.log('dev downloadu url', url)
        link.href = url;
        link.download = parsedUrl.searchParams.get("file"); // Název souboru
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      })
          .catch((err) => {
            console.error("getVendorClients ERR", err);
          })
    },
    formatDate(dt) {
      return  dt;
    },
    formatDatetime(dt) {
      return  dt;
    }
  },
  watch: {

  },
};
</script>
<style type="text/scss">
.fs-7 {
  font-size: .875rem !important
}

.bsb-timeline-8 {
  --bsb-tl-color: var(--bs-secondary-bg-subtle);
  --bsb-tl-circle-color: var(--bs-light);
  --bsb-tl-circle-border-color: var(--bs-secondary);
  --bsb-tl-indicator-color: var(--bs-white);
  --bsb-tl-circle-size: 16px;
  --bsb-tl-circle-offset: 8px;
  --bsb-tl-circle-border-size: 1px
}

.bsb-timeline-8 .timeline {
  list-style: none;
  margin: 0;
  padding: 0;
  position: relative
}

.bsb-timeline-8 .timeline:after {
  background-color: var(--bsb-tl-color);
  bottom: 0;
  content: "";
  left: 0;
  margin-left: -1px;
  position: absolute;
  top: 0;
  width: 2px
}

@media (min-width: 768px) {
  .bsb-timeline-8 .timeline:after {
    left: 20%;
    /*left: 33%*/
  }
}

.bsb-timeline-8 .timeline > .timeline-item {
  margin: 0;
  padding: 0;
  position: relative
}

.bsb-timeline-8 .timeline > .timeline-item:after {
  background: var(--bsb-tl-circle-color);
  border: var(--bsb-tl-circle-border-size) solid var(--bsb-tl-circle-border-color);
  border-radius: 50%;
  content: "";
  height: var(--bsb-tl-circle-size);
  left: calc(var(--bsb-tl-circle-offset) * -1);
  position: absolute;
  top: calc(50% - var(--bsb-tl-circle-offset));
  width: var(--bsb-tl-circle-size);
  z-index: 1
}

.bsb-timeline-8 .timeline > .timeline-item .timeline-body {
  margin: 0;
  padding: 0;
  position: relative
}

.bsb-timeline-8 .timeline > .timeline-item .timeline-meta {
  padding: 0 0 1rem 2rem
}

.bsb-timeline-8 .timeline > .timeline-item:first-child .timeline-meta {
  padding: 2rem 0 1rem 2rem
}

.bsb-timeline-8 .timeline > .timeline-item .timeline-content {
  padding: 0 0 2rem 2rem
}

@media (min-width: 768px) {
  .bsb-timeline-8 .timeline > .timeline-item {
    left: 20%;
    /*left: 33%;   */
    width: 67%
  }

  .bsb-timeline-8 .timeline > .timeline-item .timeline-meta {
    display: flex;
    justify-content: flex-end;
    left: -100%;
    margin: 0;
    padding: 0 2rem 0 0;
    position: absolute;
    top: calc(50% - 10px);
    width: 100%;
    z-index: 1
  }

  .bsb-timeline-8 .timeline > .timeline-item:first-child .timeline-meta {
    padding: 0 2rem 0 0
  }

  .bsb-timeline-8 .timeline > .timeline-item .timeline-content {
    padding: 2rem
  }

  .bsb-timeline-8 .timeline > .timeline-item .timeline-indicator {
    position: relative
  }

  .bsb-timeline-8 .timeline > .timeline-item .timeline-indicator:after {
    border-width: 1px;
    border: 10px solid var(--bsb-tl-indicator-color);
    border-color: transparent var(--bsb-tl-indicator-color) transparent transparent;
    border-left-width: 0;
    content: "";
    left: calc(2rem - 10px);
    position: absolute;
    top: calc(50% - var(--bsb-tl-circle-offset));
    z-index: 1
  }
}
</style>